import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Ad, EditAd, Media, MediaFolder } from "../../../types";
import {
  Modal,
  ModalBody,
  ModalClose,
  ModalHeader,
  ModalTitle,
} from "../../UI/Modal";
import AdForm from "../AdForm";

type Props = {
  ad?: Ad;
  isOpen: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  onSubmit: (data: EditAd) => void;
  onChangeFolder: (folderId: MediaFolder["projectId"]) => void;
  medias: Media[];
};

const AdModal: FC<Props> = ({
  ad,
  isOpen,
  isSubmitting,
  onClose,
  onSubmit,
  onChangeFolder,
  medias,
}) => {
  const { t } = useTranslation();

  return (
    <Modal show={isOpen} onClose={() => {}}>
      <ModalHeader>
        <ModalTitle>
          {ad
            ? t("components.screenAdvertisingDetail.adModal.typeEdit")
            : t("components.screenAdvertisingDetail.adModal.typeNew")}
        </ModalTitle>
        <ModalClose onClose={onClose}>x</ModalClose>
      </ModalHeader>
      <ModalBody>
        <AdForm
          isSubmitting={isSubmitting}
          editable
          isAdmin
          onSubmit={(data: any) => onSubmit(data)}
          validable={false}
          onCancel={onClose}
          ad={ad}
          onChangeFolder={onChangeFolder}
          medias={medias}
        />
      </ModalBody>
    </Modal>
  );
};

export default AdModal;
